import { render } from "./Index.vue?vue&type=template&id=71134186&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-71134186"

export default script